export default __webpack_public_path__ + "static/media/green-checkmark.667c42ec.svg";